<template>
  <div>
    <i-bar :title="dp_title" class="window-header" :color="color" :type=type />

    <div class="alert_msg" :class=[type] v-show="!!message" v-html="message" />

    <div class="btn_group" style="padding: 10px; margin-top: 0px;">
      <button type="button" class="btn right" style="background-color: white; margin-left: 10px;" v-if="alert != true" @click="cb_cancel2" @keydown.enter.prevent="cb_cancel2">취소</button>
      <button type="button" class="btn right" style="background-color: white;"                             ref="agree" @click="cb_agree2"  @keydown.enter.prevent="cb_agree2" >확인</button>
      <!-- .enter.prevent 를 사용하면 적어도 동일 element 의 @click 은 호출하지 않는다... 원하는건 모달이 닫힌 이후에 부모쪽에도 영향이 안갔으면 좋겠는데 그건 안된다 ㅠ -->
    </div>
  </div>
</template>

<style scoped>
.alert_msg.error {
  font-size: 17px;
  color: black;
}
</style>

<script>
export default {
  props : {
    alert: { type: Boolean, default: false, },
    title: { },
    message: { required: true },
    color: { default: 'primary'},
    cb_agree: { type: Function, },
    cb_cancel: { type: Function, },
    type: { default: 'normal'},
  },
  computed: {
    dp_title() {
      if (this.title) return this.title
      return this.alert ? "알림" : "확인"
    },
  },
  mounted() {
    setTimeout(() => this.$refs.agree.focus(),100); // 보기 흉하지만.. 확실히 보더가 생김 focus 제대로 된 것처럼 보임
  },
  methods: {
    cb_cancel2(event) {
      // console.log("호출 엔터 :", event);
      // if (event) event.preventDefault() // 안먹힘
      // console.log("취소 엔터 :", event);
      // this.$nextTick(v=>this.cb_agree())
      this.$emit('close') // 200ms 기다리기 힘드니깐 모달은 먼저 닫는다
      setTimeout(() => this.cb_cancel(),200); // preventDefault, .stop.prevent 등등 다 안먹는다. 오로지 setTimeout 만이 엔터입력한걸 없앨 수 있다.. 그것도 100ms 도 안된다. 200ms 줘야 한다 ㅠ
    },
    cb_agree2(event) {
      // console.log("호출 엔터 :", event);
      // if (event) event.preventDefault() // 안먹힘
      // console.log("확인 엔터 :", event);
      // this.$nextTick(v=>this.cb_agree())
      this.$emit('close') // 200ms 기다리기 힘드니깐 모달은 먼저 닫는다
      setTimeout(() => this.cb_agree(),200); // 보기 흉하지만.. 확실히 보더가 생김 focus 제대로 된 것처럼 보임
    },
  }
}
</script>
